import React, { useState, useRef } from 'react';
import Select, { SelectInstance } from 'react-select';
import type { SelectItem } from '../../../../../models/select/selectItem';
import { fromCompany } from '../../../../../models/select/selectItem';
import type { Company } from '../../../../../models/companies/company';

interface Props {
  companies: Company[];
  inputName?: string;
  className?: string;
  defaultCompanyId: number | null;
  placeholder?: string;
}

export default function SelectCompaniesView(props: Props) {
  const { companies, inputName, className, defaultCompanyId, placeholder } =
    props;
  const [options] = useState<SelectItem[]>(() => fromCompany(companies));
  const [selectedOption, setSelectedOption] = useState<SelectItem | null>(
    () => options.find(item => item.value === defaultCompanyId) ?? null,
  );
  const selectRef = useRef<SelectInstance<SelectItem> | null>(null);

  const handleChangeValue = (data: SelectItem | null) => {
    setSelectedOption(data);
  };

  // 事業者を選択時にEnter押すとPOSTリクエストが飛んでしまうため、そうならないようにEnter押下時の処理を追加
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const select = selectRef.current;
    if (!select) return;

    switch (event.key) {
      case 'Enter':
        // IME の変換確定の Enter では何もしない（メニューの開閉や選択をしない）
        if (event.nativeEvent.isComposing || select.isComposing) return;
        event.preventDefault();
        if (!select.props.menuIsOpen) {
          select.openMenu('first');
          break;
        } else {
          const { focusedOption } = select.state;
          if (!focusedOption) return;
          select.selectOption(focusedOption);
          break;
        }
    }
  };

  return (
    <Select
      value={selectedOption}
      name={inputName}
      className={className}
      ref={selectRef}
      isClearable={true}
      onChange={handleChangeValue}
      onKeyDown={onKeyDown}
      options={options}
      noOptionsMessage={() => '選択可能な銘柄がありません。'}
      placeholder={placeholder ?? ''}
    />
  );
}
